
import routes from './routes'
import { Fetch } from '../fetch'

class Faqs {
  async fetchFaqs () {
    return Fetch('get', routes.Faqs)
  }
}

export default new Faqs()
